// extracted by mini-css-extract-plugin
export default {"btn":"switch_btn__ohhM8","checked":"switch_checked__RXedO","circle":"switch_circle__0eYMx"};